import React, { useCallback } from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import Select from "react-select";
// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { Query, useMutation } from "react-apollo";
import { GET_CLIENT, GET_CHALLENGES } from "../graphql/challengeQueries";

import map from "lodash/map";
import compact from "lodash/compact";
import unset from "lodash/unset";
import head from "lodash/head";
import set from "lodash/set";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import concat from "lodash/concat";
import slice from "lodash/slice";
import debounce from "lodash/debounce";
import isEqual from "lodash/isEqual";

import withSession from "./withSession";
import {
  ADD_CHALLENGE,
  UPDATE_CHALLENGE,
  DELETE_CHALLENGE,
  IMAGE_UPLOAD,
  PUBLISH_CHALLENGE,
  COPY_CHALLENGE,
} from "../graphql/challengeMutations";
import Dropzone from "react-dropzone";
import ReactQuill from "react-quill";
import { modules } from "constants/reactQuill";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./Forms/SignUpWizard/datePicker.css";

import {
  MAXSIZE,
  FILETYPES,
  typeOptions,
  options,
  ageOptions,
} from "../constants/challengeConstants";
import { createChallenge } from "../utils/challengeHelpers";

// Utility function to remove __typename and preserve _id fields
const cleanChallengeData = (data) => {
  if (!data) return data;

  // Create a new object without __typename
  const { __typename, ...cleaned } = data;

  // Clean welcomeItem
  if (cleaned.welcomeItem) {
    const { __typename: welcomeTypename, ...welcomeData } = cleaned.welcomeItem;
    cleaned.welcomeItem = welcomeData;

    if (cleaned.welcomeItem.tasks) {
      cleaned.welcomeItem.tasks = cleaned.welcomeItem.tasks.map((task) => {
        const { __typename: taskTypename, ...taskData } = task;
        return taskData;
      });
    }
    if (cleaned.welcomeItem.habits) {
      cleaned.welcomeItem.habits = cleaned.welcomeItem.habits.map((habit) => {
        const { __typename: habitTypename, ...habitData } = habit;
        return habitData;
      });
    }
  }

  // Clean endingItem
  if (cleaned.endingItem) {
    const { __typename: endingTypename, ...endingData } = cleaned.endingItem;
    cleaned.endingItem = endingData;

    if (cleaned.endingItem.tasks) {
      cleaned.endingItem.tasks = cleaned.endingItem.tasks.map((task) => {
        const { __typename: taskTypename, ...taskData } = task;
        return taskData;
      });
    }
    if (cleaned.endingItem.habits) {
      cleaned.endingItem.habits = cleaned.endingItem.habits.map((habit) => {
        const { __typename: habitTypename, ...habitData } = habit;
        return habitData;
      });
    }
  }

  // Clean schedule
  if (cleaned.schedule) {
    cleaned.schedule = cleaned.schedule.map((item) => {
      const { __typename: itemTypename, ...itemData } = item;

      if (itemData.tasks) {
        itemData.tasks = itemData.tasks.map((task) => {
          const { __typename: taskTypename, ...taskData } = task;
          return taskData;
        });
      }

      if (itemData.habits) {
        itemData.habits = itemData.habits.map((habit) => {
          const { __typename: habitTypename, ...habitData } = habit;
          return habitData;
        });
      }

      return itemData;
    });
  }

  return cleaned;
};
import WelcomeSection from "components/ChallengeManager/WelcomeSection";
import EndingSection from "components/ChallengeManager/EndingSection";
import ScheduleItemSection from "../components/ChallengeManager/ScheduleItemSection";
import ImageUploadField from "../components/ChallengeManager/ImageUploadField";

function ChallengeManager(props) {
  const [modal, setModal] = React.useState(false);
  const [publishModal, setPublishModal] = React.useState(false);
  const [unpublishModal, setUnpublishModal] = React.useState(false);
  const [copyModal, setCopyModal] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [modalPassword, setModalPassword] = React.useState(false);

  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [difficulty, setDifficulty] = React.useState("");
  const [duration, setDuration] = React.useState(0);
  const [timedChallenge, setTimedChallenge] = React.useState(false);
  const [startDate, setStartDate] = React.useState("");
  const [challengeType, setChallengeType] = React.useState(head(typeOptions));
  const [communityId, setCommunityId] = React.useState(null);
  const [commitment, setCommitment] = React.useState("");
  const [imageLink, setImageLink] = React.useState("");
  const [scheduleItems, setScheduleItems] = React.useState([]);
  const [welcomeItem, setWelcomeItem] = React.useState({});
  const [endingItem, setEndingItem] = React.useState({});
  const [showError, setShowError] = React.useState("");
  const [showErrorConfirm, setShowErrorConfirm] = React.useState("");
  const [activeItem, setActiveItem] = React.useState({
    value: "welcome",
    label: "Welcome",
  });
  const [editChallengeId, setEditChallengeId] = React.useState("");
  const [publishChallengeId, setPublishChallengeId] = React.useState("");
  const [copyChallenge, setCopyChallenge] = React.useState(null);
  const [deleteChallengeId, setDeleteChallengeId] = React.useState("");
  const [initialFormState, setInitialFormState] = React.useState(null);
  const [modalReady, setModalReady] = React.useState(false);
  const [published, setPublished] = React.useState(false);
  // const [multipleActivities, setMultipleActivities] = React.useState("");

  // Set initial form state when modal is ready
  React.useEffect(() => {
    if (modalReady && modal) {
      setInitialFormState(getCurrentFormState());
      setModalReady(false);
    }
  }, [modalReady, modal]);

  const [addChallenge] = useMutation(ADD_CHALLENGE);
  const [updateChallenge] = useMutation(UPDATE_CHALLENGE);
  const [publishChallenge] = useMutation(PUBLISH_CHALLENGE);
  const [copyChallengeMutation] = useMutation(COPY_CHALLENGE);
  const [deleteChallenge] = useMutation(DELETE_CHALLENGE);
  const [uploadImage] = useMutation(IMAGE_UPLOAD);

  const validateFile = (file) => {
    if (file.size > MAXSIZE) {
      // this.setState({ error: 'file is too big' })
      return false;
    }

    // if (!includes(FILETYPES, file.type)) {
    //   this.setState({
    //     error: 'File Type not accepted',
    //     progress: null,
    //   })
    //   return false
    // }
    return true;
  };
  const getBase64ImageFromFile = async (file) => {
    if (!file) return null;
    console.log("getBase64ImageFromFile called with file:", {
      name: file.name,
      size: file.size,
      type: file.type,
    });

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          console.log(
            "FileReader load event fired, result length:",
            reader.result ? reader.result.length : 0
          );
          resolve(reader.result);
        },
        false
      );

      reader.onerror = (error) => {
        console.error("FileReader error:", error);
        return reject(error);
      };

      console.log("Starting FileReader.readAsDataURL...");
      reader.readAsDataURL(file);
    });
  };
  const handleOnDrop = async (files, rejectedFiles) => {
    console.log("handleOnDrop called with:", { files, rejectedFiles });

    try {
      // this.setState({ error: null, progress: files.length })
      let urls = await Promise.all(
        map(files, async (file) => {
          console.log("Processing file in handleOnDrop:", {
            name: file.name,
            size: file.size,
            type: file.type,
          });
          if (validateFile(file)) {
            console.log(
              "File validated in handleOnDrop, converting to base64..."
            );
            const url = await getBase64ImageFromFile(file);
            console.log("Base64 conversion completed in handleOnDrop");
            return url;
          } else {
            console.log("File validation failed in handleOnDrop");
            return null;
          }
        })
      );
      console.log("All files processed in handleOnDrop, urls:", urls);

      // Validate client name before upload
      const clientName = props?.session?.me?.clientName;
      if (!clientName) {
        setShowError("Image upload failed: Client name is not available");
        console.error("Image upload error: Client name is undefined");
        return;
      }

      console.log(
        "Uploading main challenge image with collection:",
        `${clientName}/challenges`
      );

      // setImageLink(head(urls))
      uploadImage({
        variables: {
          fileUrl: head(urls),
          collection: `${clientName}/challenges`,
        },
      })
        .then((data) => {
          setImageLink(data?.data?.uploadImage);
        })
        .catch((error) => {
          setShowError("Image upload failed: " + (error.message || error));
          console.error("Image upload error:", error);
        });
    } catch (error) {
      console.error("Error in handleOnDrop:", error);
      setShowError("Image upload failed: " + (error.message || error));
    }
  };

  const handleOnDropSchedule =
    (index, admin = false) =>
    async (files, rejectedFiles) => {
      console.log("handleOnDropSchedule called with:", {
        files,
        rejectedFiles,
        index,
        admin,
      });

      try {
        // this.setState({ error: null, progress: files.length })
        let urls = await Promise.all(
          map(files, async (file) => {
            console.log("Processing file:", {
              name: file.name,
              size: file.size,
              type: file.type,
            });
            if (validateFile(file)) {
              console.log("File validated, converting to base64...");
              const url = await getBase64ImageFromFile(file);
              console.log("Base64 conversion completed");
              return url;
            } else {
              console.log("File validation failed");
              return null;
            }
          })
        );
        console.log("All files processed, urls:", urls);

        // Validate client name before upload
        const clientName = props?.session?.me?.clientName;
        if (!clientName) {
          setShowError("Image upload failed: Client name is not available");
          console.error("Image upload error: Client name is undefined");
          return;
        }

        console.log(
          "Uploading image with collection:",
          `${clientName}/CommunityImage`
        );

        uploadImage({
          variables: {
            fileUrl: head(urls),
            collection: `${clientName}/CommunityImage`,
          },
        })
          .then((data) => {
            if (index === "welcome") {
              onChangeScheduleItem(
                data?.data?.uploadImage,
                admin ? "adminCommunityPostImage" : "communityPostImage",
                index,
                welcomeItem
              );
            } else {
              // For schedule items, we need to update the community array
              onChangeScheduleItem(
                data?.data?.uploadImage,
                admin
                  ? "adminCommunity.0.adminCommunityPostImage"
                  : "community.0.communityPostImage",
                index,
                welcomeItem
              );
            }
          })
          .catch((error) => {
            setShowError("Image upload failed: " + (error.message || error));
            console.error("Image upload error:", error);
          });
      } catch (error) {
        console.error("Error in handleOnDropSchedule:", error);
        setShowError("Image upload failed: " + (error.message || error));
      }
    };

  const handleClose = () => {
    setModal(false);
    setTitle("");
    setDescription("");
    setDuration(0);
    setTimedChallenge(false);
    setStartDate("");
    setChallengeType(head(typeOptions));
    setCommunityId(null);
    setDifficulty("");
    setCommitment("");
    setImageLink("");
    setWelcomeItem({});
    setEndingItem({});
    setScheduleItems([]);
    setActiveItem({ value: "welcome", label: "Welcome" });
    setEditChallengeId("");
    setPublished(false);
    setInitialFormState(null);
    setModalReady(false);
  };

  const handleOpenPublish = (challenge) => {
    setPublishModal(true);
    setPublishChallengeId(challenge?._id);
  };

  const handleClosePublish = (user) => {
    setPublishModal(false);
    setPublishChallengeId("");
  };

  const handleOpenUnpublish = (challenge) => {
    setUnpublishModal(true);
    setPublishChallengeId(challenge?._id);
  };

  const handleCloseUnpublish = (user) => {
    setUnpublishModal(false);
    setPublishChallengeId("");
  };

  const handleOpenCopy = (challenge) => {
    setCopyModal(true);
    setCopyChallenge(challenge);
  };

  const handleCloseCopy = (user) => {
    setCopyModal(false);
    setCopyChallenge(null);
  };

  const handleOpenDelete = (challenge) => {
    setDeleteModal(true);
    setDeleteChallengeId(challenge?._id);
  };

  const handleCloseDelete = (user) => {
    setDeleteModal(false);
    setDeleteChallengeId("");
  };

  const handleChangeDuration = (value) => {
    setDuration(value);
    let newScheduleItems = cloneDeep(scheduleItems);
    // Changing slice to only occur when saving
    // if (newScheduleItems.length > value)
    //   newScheduleItems = slice(newScheduleItems, 0, value);
    while (newScheduleItems.length < value) {
      newScheduleItems.push({});
    }
    setScheduleItems(newScheduleItems);
  };

  const onChangeScheduleItem = (
    value,
    name,
    index,
    welcomeItemParam = null
  ) => {
    // Normalize value - convert null/undefined to empty string for text fields
    let normalizedValue = value === null || value === undefined ? "" : value;

    // Trim video links to remove trailing spaces
    if (name === "videoLink" && typeof normalizedValue === "string") {
      normalizedValue = normalizedValue.trim();
    }

    // Debug logging removed for production

    if (index === "welcome") {
      let newItem = cloneDeep(welcomeItem);
      // Ensure the item exists
      if (!newItem) {
        newItem = {
          title: "",
          description: "",
          videoLink: "",
          lessonText: "",
          activities: [],
          habits: [],
        };
      }
      set(newItem, `${name}`, normalizedValue);

      setWelcomeItem(newItem);
    } else if (index === "ending") {
      let newItem = cloneDeep(endingItem);
      // Ensure the item exists
      if (!newItem) {
        newItem = {
          title: "",
          description: "",
          videoLink: "",
          lessonText: "",
          activities: [],
          habits: [],
        };
      }
      set(newItem, `${name}`, normalizedValue);

      setEndingItem(newItem);
    } else {
      setScheduleItems((prevScheduleItems) => {
        let newScheduleItems = cloneDeep(prevScheduleItems);
        const defaultItem = {
          title: "",
          description: "",
          videoLink: "",
          lessonText: "",
          activities: [],
          habits: [],
        };

        if (!newScheduleItems[index]) {
          newScheduleItems[index] = { ...defaultItem };
        }
        // Always start from a full default object, then merge in the current item
        const currentItem = newScheduleItems[index];

        const updatedItem = { ...defaultItem, ...currentItem };
        if (
          name.startsWith("community.") ||
          name.startsWith("adminCommunity.")
        ) {
          const [arrayName, elementIndex, fieldName] = name.split(".");
          // Debug logging removed for production
          if (!updatedItem[arrayName]) {
            updatedItem[arrayName] = [];
          }
          if (!updatedItem[arrayName][elementIndex]) {
            updatedItem[arrayName][elementIndex] = {};
          }
          set(updatedItem, name, normalizedValue);
          // Debug logging removed for production
        } else {
          set(updatedItem, name, normalizedValue);
        }

        newScheduleItems[index] = updatedItem;

        return newScheduleItems;
      });
    }
  };

  const handleAddChallenge = () => {
    const challengeData = createChallenge({
      title,
      description,
      difficulty,
      duration,
      timedChallenge,
      startDate,
      challengeType,
      commitment,
      imageLink,
      welcomeItem,
      endingItem,
      scheduleItems,
    });

    // Clean the challenge data to remove __typename and preserve _id fields
    const cleanedChallengeData = cleanChallengeData(challengeData);

    addChallenge({
      variables: {
        clientName: props?.session?.me?.clientName,
        challenge: cleanedChallengeData,
      },
      refetchQueries: [
        {
          query: GET_CHALLENGES,
          variables: {
            clientName: props?.session?.me?.clientName,
          },
        },
        {
          query: GET_CLIENT,
          variables: {
            name: props?.session?.me?.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleCopyChallenge = () => {
    copyChallengeMutation({
      variables: {
        challengeId: copyChallenge._id,
      },
      refetchQueries: [
        {
          query: GET_CHALLENGES,
          variables: {
            clientName: props?.session?.me?.clientName,
          },
        },
        {
          query: GET_CLIENT,
          variables: {
            name: props?.session?.me?.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleCloseCopy();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleOpenEdit = (challenge) => {
    setModal(true);
    setTitle(challenge?.title || "");
    setDescription(challenge?.description || "");
    setDuration(challenge?.duration);
    setTimedChallenge(Boolean(challenge?.startDate));
    setStartDate(challenge?.startDate);
    setChallengeType(
      typeOptions.find((option) => option.value === challenge?.type) ||
        head(typeOptions)
    );
    setCommunityId(challenge?.communityId);
    setDifficulty(challenge?.difficulty);
    setCommitment(challenge?.commitment);
    setImageLink(challenge?.imageLink || "");
    setPublished(Boolean(challenge?.published));

    // Ensure welcomeItem has no null values
    const cleanWelcomeItem = challenge?.welcomeItem
      ? {
          ...challenge.welcomeItem,
          title: challenge.welcomeItem.title || "",
          description: challenge.welcomeItem.description || "",
          videoLink: challenge.welcomeItem.videoLink || "",
          lessonText: challenge.welcomeItem.lessonText || "",
          activities: challenge.welcomeItem.activities || [],
          habits: challenge.welcomeItem.habits || [],
          community: challenge.welcomeItem.community || [],
          adminCommunity: challenge.welcomeItem.adminCommunity || [],
        }
      : {
          title: "",
          description: "",
          videoLink: "",
          lessonText: "",
          activities: [],
          habits: [],
          community: [],
          adminCommunity: [],
        };

    // Ensure endingItem has no null values
    const cleanEndingItem = challenge?.endingItem
      ? {
          ...challenge.endingItem,
          title: challenge.endingItem.title || "",
          description: challenge.endingItem.description || "",
          videoLink: challenge.endingItem.videoLink || "",
          lessonText: challenge.endingItem.lessonText || "",
          activities: challenge.endingItem.activities || [],
          habits: challenge.endingItem.habits || [],
          community: challenge.endingItem.community || [],
          adminCommunity: challenge.endingItem.adminCommunity || [],
        }
      : {
          title: "",
          description: "",
          videoLink: "",
          lessonText: "",
          activities: [],
          habits: [],
          community: [],
          adminCommunity: [],
        };

    // Ensure scheduleItems have no null values
    const cleanScheduleItems = challenge?.schedule
      ? challenge.schedule.map((item) => ({
          ...item,
          title: item.title || "",
          description: item.description || "",
          videoLink: item.videoLink || "",
          lessonText: item.lessonText || "",
          activities: item.activities || [],
          habits: item.habits || [],
          community: item.community || [],
          adminCommunity: item.adminCommunity || [],
        }))
      : [];

    setWelcomeItem(cleanWelcomeItem);
    setEndingItem(cleanEndingItem);
    setScheduleItems(cleanScheduleItems);
    setEditChallengeId(challenge?._id);
    setShowError("");
  };

  const handleEditChallenge = async (editChallengeId) => {
    const challengeUpdate = {
      ...createChallenge({
        title,
        description,
        difficulty,
        duration,
        timedChallenge,
        startDate,
        challengeType,
        commitment,
        imageLink,
        welcomeItem,
        endingItem,
        scheduleItems,
      }),
      communityId: timedChallenge ? communityId : null,
      published, // <-- Add this line to preserve published status
    };

    // Clean the challenge data to remove __typename and preserve _id fields
    const cleanedChallengeUpdate = cleanChallengeData(challengeUpdate);

    // Use cleanedChallengeUpdate for your mutation
    try {
      await updateChallenge({
        variables: {
          challengeId: editChallengeId,
          challengeUpdate: cleanedChallengeUpdate,
        },
        refetchQueries: [
          {
            query: GET_CHALLENGES,
            variables: {
              clientName: props?.session?.me?.clientName,
            },
          },
          {
            query: GET_CLIENT,
            variables: {
              name: props?.session?.me?.clientName,
            },
          },
        ],
      })
        .then(() => {
          handleClose();
        })
        .catch((error) => {
          setShowError(error.message);
        });
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating challenge:", error);
    }
  };

  const handlePublishChallenge = async (publishChallengeId) => {
    try {
      await publishChallenge({
        variables: {
          challengeId: publishChallengeId,
        },
        refetchQueries: [
          {
            query: GET_CHALLENGES,
            variables: {
              clientName: props?.session?.me?.clientName,
            },
          },
          {
            query: GET_CLIENT,
            variables: {
              name: props?.session?.me?.clientName,
            },
          },
        ],
      })
        .then(() => {
          handleClosePublish();
        })
        .catch((error) => {
          setShowError(error.message);
        });
      // Handle successful update, e.g., showing a success message or redirecting
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating challenge:", error);
    }
  };

  const handleUnpublishChallenge = async (publishChallengeId) => {
    try {
      await publishChallenge({
        variables: {
          challengeId: publishChallengeId,
          publish: false,
        },
        refetchQueries: [
          {
            query: GET_CHALLENGES,
            variables: {
              clientName: props?.session?.me?.clientName,
            },
          },
          {
            query: GET_CLIENT,
            variables: {
              name: props?.session?.me?.clientName,
            },
          },
        ],
      })
        .then(() => {
          handleClosePublish();
          handleCloseUnpublish();
        })
        .catch((error) => {
          setShowError(error.message);
        });
      // Handle successful update, e.g., showing a success message or redirecting
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating challenge:", error);
    }
  };

  const handleDeleteChallenge = async (deleteChallengeId) => {
    try {
      await deleteChallenge({
        variables: {
          challengeId: deleteChallengeId,
        },
        refetchQueries: [
          {
            query: GET_CHALLENGES,
            variables: {
              clientName: props?.session?.me?.clientName,
            },
          },
          {
            query: GET_CLIENT,
            variables: {
              name: props?.session?.me?.clientName,
            },
          },
        ],
      })
        .then(() => {
          handleCloseDelete();
        })
        .catch((error) => {
          setShowError(error.message);
        });
      // Handle successful update, e.g., showing a success message or redirecting
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error deleting challenge:", error);
    }
  };

  // Helper to get the current form state for comparison
  const getCurrentFormState = () => ({
    title,
    description,
    difficulty,
    duration,
    timedChallenge,
    startDate,
    challengeType,
    communityId,
    commitment,
    imageLink,
    welcomeItem,
    endingItem,
    scheduleItems,
  });

  // When opening the modal for add/edit, save the initial state
  const openModalForNew = () => {
    setTitle("");
    setDescription("");
    setDifficulty("");
    setDuration(0);
    setTimedChallenge(false);
    setStartDate("");
    setChallengeType(head(typeOptions));
    setCommunityId(null);
    setCommitment("");
    setImageLink("");
    setWelcomeItem({});
    setEndingItem({});
    setScheduleItems([]);
    setActiveItem({ value: "welcome", label: "Welcome" });
    setEditChallengeId("");
    setPublished(false);
    setShowError("");
    setModal(true);
    setModalReady(true);
  };
  const openModalForEdit = (challenge) => {
    setModal(true);
    setTitle(challenge?.title || "");
    setDescription(challenge?.description || "");
    setDuration(challenge?.duration);
    setTimedChallenge(Boolean(challenge?.startDate));
    setStartDate(challenge?.startDate);
    setChallengeType(
      typeOptions.find((option) => option.value === challenge?.type) ||
        head(typeOptions)
    );
    setCommunityId(challenge?.communityId);
    setDifficulty(challenge?.difficulty);
    setCommitment(challenge?.commitment);
    setImageLink(challenge?.imageLink || "");
    setPublished(Boolean(challenge?.published));

    // Clean the challenge data to remove __typename and preserve _id fields
    const cleanedChallenge = cleanChallengeData(challenge);

    // Ensure welcomeItem has no null values
    const cleanWelcomeItem = cleanedChallenge?.welcomeItem
      ? {
          ...cleanedChallenge.welcomeItem,
          title: cleanedChallenge.welcomeItem.title || "",
          description: cleanedChallenge.welcomeItem.description || "",
          videoLink: cleanedChallenge.welcomeItem.videoLink || "",
          lessonText: cleanedChallenge.welcomeItem.lessonText || "",
          activities: cleanedChallenge.welcomeItem.activities || [],
          habits: cleanedChallenge.welcomeItem.habits || [],
          community: cleanedChallenge.welcomeItem.community || [],
          adminCommunity: cleanedChallenge.welcomeItem.adminCommunity || [],
        }
      : {
          title: "",
          description: "",
          videoLink: "",
          lessonText: "",
          activities: [],
          habits: [],
          community: [],
          adminCommunity: [],
        };
    // Ensure endingItem has no null values
    const cleanEndingItem = cleanedChallenge?.endingItem
      ? {
          ...cleanedChallenge.endingItem,
          title: cleanedChallenge.endingItem.title || "",
          description: cleanedChallenge.endingItem.description || "",
          videoLink: cleanedChallenge.endingItem.videoLink || "",
          lessonText: cleanedChallenge.endingItem.lessonText || "",
          activities: cleanedChallenge.endingItem.activities || [],
          habits: cleanedChallenge.endingItem.habits || [],
          community: cleanedChallenge.endingItem.community || [],
          adminCommunity: cleanedChallenge.endingItem.adminCommunity || [],
        }
      : {
          title: "",
          description: "",
          videoLink: "",
          lessonText: "",
          activities: [],
          habits: [],
          community: [],
          adminCommunity: [],
        };
    // Ensure scheduleItems have no null values
    const cleanScheduleItems = cleanedChallenge?.schedule
      ? cleanedChallenge.schedule.map((item) => {
          return {
            ...item,
            title: item.title || "",
            description: item.description || "",
            videoLink: item.videoLink || "",
            lessonText: item.lessonText || "",
            activities: item.activities || [],
            habits: item.habits || [],
            community: item.community || [],
            adminCommunity: item.adminCommunity || [],
          };
        })
      : [];
    setWelcomeItem(cleanWelcomeItem);
    setEndingItem(cleanEndingItem);
    setScheduleItems(cleanScheduleItems);
    setEditChallengeId(challenge?._id);
    setShowError("");
    setModalReady(true);
  };

  // Helper to check for unsaved changes
  const hasUnsavedChanges =
    initialFormState && !isEqual(getCurrentFormState(), initialFormState);

  // Intercept modal close
  const handleModalClose = () => {
    if (hasUnsavedChanges) {
      if (
        window.confirm(
          "You have unsaved changes. Are you sure you want to discard them?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  return (
    <Query
      query={GET_CHALLENGES}
      variables={{
        clientName: props?.session?.me?.clientName,
      }}
    >
      {({
        loading: challengesLoading,
        data: challengesData,
        error: challengesError,
      }) => {
        if (challengesLoading) return "Loading...";
        if (challengesError) {
          console.error("GraphQL Error:", challengesError);
          return <div>Error loading challenges: {challengesError.message}</div>;
        }

        return (
          <Query
            query={GET_CLIENT}
            variables={{
              name: props?.session?.me?.clientName,
            }}
          >
            {({
              loading: clientLoading,
              data: clientData,
              error: clientError,
            }) => {
              if (clientLoading) return "Loading...";
              if (clientError) {
                console.error("GraphQL Error:", clientError);
                return (
                  <div>Error loading client data: {clientError.message}</div>
                );
              }
              if (!clientData) {
                return <div>No client data available</div>;
              }

              const { getClient } = clientData;
              const { habits, adminUsers = [] } = getClient || {};
              const challenges = challengesData?.getChallenges || [];

              const tableData = map(challenges, (challenge, key) => {
                return {
                  id: key,
                  ...challenge,
                  challenge,
                  published: challenge?.published ? "Yes" : "No",
                };
              });
              return (
                <>
                  <Container fluid>
                    <Row>
                      <Col md="12">
                        <h4 className="title">Challenge Manager</h4>
                        {/* <p className="category">
                          A powerful react plugin handcrafted by our friends from{" "}
                          <a
                            href="https://react-table.tanstack.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            react-table
                          </a>
                          . It is a highly flexible tool, based upon the foundations of
                          progressive enhancement on which you can add advanced interaction
                          controls. Please check out their{" "}
                          <a
                            href="https://react-table.tanstack.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            full documentation.
                          </a>
                        </p> */}
                        <Card>
                          <Card.Body>
                            <ReactTable
                              data={tableData}
                              columns={[
                                {
                                  header: "Title",
                                  accessorKey: "title",
                                },
                                {
                                  header: "Challenge Description",
                                  accessorKey: "description",
                                },
                                {
                                  header: "Challenge duration",
                                  accessorKey: "duration",
                                },
                                {
                                  header: "Challenge Commitment",
                                  accessorKey: "commitment",
                                },
                                {
                                  header: "Image Link",
                                  accessorKey: "imageLink",
                                },
                                {
                                  header: "Published",
                                  accessorKey: "published",
                                },
                                {
                                  header: "Actions",
                                  accessorKey: "actions",
                                  enableSorting: false,
                                  enableColumnFilter: false,
                                  cell: ({ row }) => {
                                    const { challenge } = row.original;
                                    return (
                                      // we've added some custom button actions
                                      <div className="actions-right">
                                        {/* use this button to add a edit kind of action */}
                                        <Button
                                          variant="success"
                                          size="sm"
                                          className="text-success btn-link edit"
                                          onClick={
                                            challenge?.published
                                              ? () =>
                                                  handleOpenUnpublish(challenge)
                                              : () =>
                                                  handleOpenPublish(challenge)
                                          }
                                        >
                                          <i className="fa fa-paper-plane" />
                                        </Button>{" "}
                                        <Button
                                          variant="warning"
                                          size="sm"
                                          className="text-warning btn-link edit"
                                          onClick={() =>
                                            openModalForEdit(challenge)
                                          }
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>{" "}
                                        <Button
                                          variant="info"
                                          size="sm"
                                          className="text-info btn-link copy"
                                          onClick={() =>
                                            handleOpenCopy(challenge)
                                          }
                                        >
                                          <i className="fa fa-copy" />
                                        </Button>{" "}
                                        <Button
                                          variant="danger"
                                          size="sm"
                                          className="text-danger btn-link edit"
                                          onClick={() =>
                                            handleOpenDelete(challenge)
                                          }
                                        >
                                          <i className="fa fa-trash" />
                                        </Button>{" "}
                                      </div>
                                    );
                                  },
                                },
                              ]}
                              /*
                                You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                              */
                              className="-striped -highlight primary-pagination"
                            />
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col
                        xs="12"
                        style={{ marginTop: 25, textAlign: "right" }}
                      >
                        <Button
                          onClick={openModalForNew}
                          style={{
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingTop: 15,
                            paddingBottom: 15,
                            fontSize: 16,
                            fontWeight: "bold",
                          }}
                        >
                          Add Challenge
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                  <Modal
                    className="modal-primary"
                    onHide={handleModalClose}
                    show={modal}
                    size="lg"
                  >
                    <Modal.Header className="justify-content-center">
                      <label>
                        {editChallengeId && editChallengeId !== ""
                          ? "Edit"
                          : "Add"}{" "}
                        Challenge
                      </label>
                    </Modal.Header>
                    <Modal.Body>
                      <Form action="#" method="#">
                        <Form.Group>
                          <label>Title</label>
                          <Form.Control
                            value={title}
                            placeholder="Title"
                            type="string"
                            onChange={(event) => setTitle(event.target.value)}
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Challenge Description</label>
                          <ReactQuill
                            key="challenge-description"
                            value={description}
                            onChange={(value) => {
                              if (value === "<p><br></p>") setDescription("");
                              else setDescription(value);
                            }}
                            modules={modules}
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Challenge Duration</label>
                          <Form.Control
                            value={duration}
                            placeholder="Challenge Duration"
                            type="number"
                            onChange={(event) =>
                              handleChangeDuration(
                                Math.floor(event.target.value)
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Check className="mb-1 pl-0">
                          <Form.Check.Label>
                            <Form.Check.Input
                              checked={timedChallenge}
                              value={timedChallenge}
                              type="checkbox"
                              onChange={(event) => {
                                setTimedChallenge(!timedChallenge);
                              }}
                            ></Form.Check.Input>
                            <span className="form-check-sign"></span>
                            Do you want to make this challenge global?
                          </Form.Check.Label>
                        </Form.Check>
                        {timedChallenge && (
                          <>
                            <Form.Group>
                              <label>Challenge Start Date</label>
                              <DatePicker
                                selected={startDate}
                                onChange={setStartDate}
                                placeholderText="Challenge Start Date"
                                customInput={
                                  <Form.Control
                                    style={{
                                      borderColor: "black",
                                      color: "black",
                                      borderWidth: 1,
                                      padding: 10,
                                      borderRadius: 50,
                                      marginBottom: 10,
                                    }}
                                  ></Form.Control>
                                }
                              />
                            </Form.Group>
                            <Form.Group>
                              <label>Challenge Type</label>
                              <Select
                                className="react-select info"
                                classNamePrefix="react-select"
                                placeholder="Choose Type"
                                name="challengeType"
                                closeMenuOnSelect={true}
                                value={challengeType} // Controlled by the selectedOption state
                                onChange={(value) => setChallengeType(value)}
                                options={typeOptions}
                              />
                            </Form.Group>
                          </>
                        )}
                        <Form.Group>
                          <label>Challenge Difficulty</label>
                          <Form.Control
                            value={difficulty}
                            placeholder="Challenge Difficulty"
                            type="string"
                            onChange={(event) =>
                              setDifficulty(event.target.value)
                            }
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Challenge Commitment</label>
                          <Form.Control
                            value={commitment}
                            placeholder="Challenge Commitment"
                            type="string"
                            onChange={(event) =>
                              setCommitment(event.target.value)
                            }
                          />
                        </Form.Group>
                        <Form.Group>
                          <label>Image</label>
                          <ImageUploadField
                            label="Image"
                            imageUrl={imageLink}
                            onDrop={(files) => {
                              if (files && files.length > 0) {
                                handleOnDrop(files);
                              }
                            }}
                            onDelete={() => setImageLink("")}
                            accept={FILETYPES}
                            maxSize={MAXSIZE}
                          />
                        </Form.Group>
                        {duration > 0 && (
                          <>
                            <Select
                              className="react-select info"
                              classNamePrefix="react-select"
                              placeholder="Choose Day"
                              name="dayDropdown"
                              closeMenuOnSelect={true}
                              value={activeItem} // Controlled by the selectedOption state
                              onChange={(value) => setActiveItem(value)}
                              options={concat(
                                [{ value: "welcome", label: `Welcome` }],
                                map(
                                  slice(scheduleItems, 0, duration),
                                  (item, index) => {
                                    return {
                                      value: index,
                                      label: `Day ${index + 1}`,
                                    };
                                  }
                                ),
                                [{ value: "ending", label: `Ending` }]
                              )}
                            />
                            <div
                              style={{
                                display:
                                  "welcome" === activeItem?.value
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <WelcomeSection
                                welcomeItem={welcomeItem}
                                onChangeScheduleItem={onChangeScheduleItem}
                                options={options}
                                habits={habits}
                                timedChallenge={timedChallenge}
                                handleOnDropSchedule={handleOnDropSchedule}
                              />
                            </div>
                            {map(
                              slice(scheduleItems, 0, duration),
                              (item, index) => {
                                const defaultItem = {
                                  title: "",
                                  description: "",
                                  videoLink: "",
                                  lessonText: "",
                                  activities: [],
                                  habits: [],
                                };
                                const mergedItem = { ...defaultItem, ...item };
                                if (index === activeItem?.value)
                                  return (
                                    <ScheduleItemSection
                                      key={`schedule-item-${index}-${
                                        item?._id || index
                                      }`}
                                      index={index}
                                      item={mergedItem}
                                      onChangeScheduleItem={
                                        onChangeScheduleItem
                                      }
                                      options={options}
                                      habits={habits}
                                      handleOnDropSchedule={
                                        handleOnDropSchedule
                                      } // Pass the upload handler
                                    />
                                  );
                                return null;
                              }
                            )}
                            <div
                              style={{
                                display:
                                  "ending" === activeItem?.value
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <EndingSection
                                endingItem={endingItem}
                                onChangeScheduleItem={onChangeScheduleItem}
                              />
                            </div>
                          </>
                        )}
                      </Form>
                    </Modal.Body>
                    <div className="modal-footer">
                      <Button
                        className="btn-simple"
                        onClick={handleModalClose}
                        variant="link"
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn-simple"
                        onClick={
                          editChallengeId
                            ? () => handleEditChallenge(editChallengeId)
                            : handleAddChallenge
                        }
                        variant="outlined"
                        color="primary"
                        disabled={
                          !title ||
                          !description ||
                          !duration ||
                          !difficulty ||
                          !commitment ||
                          !imageLink ||
                          (timedChallenge && !startDate)
                        }
                      >
                        Save
                      </Button>
                    </div>
                  </Modal>

                  <Modal
                    className="modal-primary"
                    onHide={handleClosePublish}
                    show={publishModal}
                    size="md"
                  >
                    <Modal.Header className="justify-content-center">
                      <label>Publish Challenge</label>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to publish this Challenge?
                    </Modal.Body>
                    <div className="modal-footer">
                      <Button
                        className="btn-simple"
                        onClick={handleClosePublish}
                        variant="outlined"
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn-simple"
                        onClick={() =>
                          handlePublishChallenge(publishChallengeId)
                        }
                        // variant="danger"
                        color="primary"
                      >
                        Publish Challenge
                      </Button>
                    </div>
                  </Modal>

                  <Modal
                    className="modal-primary"
                    onHide={handleCloseUnpublish}
                    show={unpublishModal}
                    size="md"
                  >
                    <Modal.Header className="justify-content-center">
                      <label>Unpublish Challenge</label>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to remove this Challenge from the
                      avalible challenges? This action cannot be undone and will
                      remove users who are currently enrolled.
                    </Modal.Body>
                    <div className="modal-footer">
                      <Button
                        className="btn-simple"
                        onClick={handleCloseUnpublish}
                        variant="outlined"
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn-simple"
                        onClick={() =>
                          handleUnpublishChallenge(publishChallengeId)
                        }
                        variant="danger"
                        color="primary"
                      >
                        Unpublish Challenge
                      </Button>
                    </div>
                  </Modal>

                  <Modal
                    className="modal-primary"
                    onHide={handleCloseCopy}
                    show={copyModal}
                    size="md"
                  >
                    <Modal.Header className="justify-content-center">
                      <label>Copy Challenge</label>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to copy this Challenge?
                    </Modal.Body>
                    <div className="modal-footer">
                      <Button
                        className="btn-simple"
                        onClick={handleCloseCopy}
                        variant="outlined"
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn-simple"
                        onClick={() => handleCopyChallenge(copyChallenge)}
                        variant="info"
                        color="primary"
                      >
                        Copy Challenge
                      </Button>
                    </div>
                  </Modal>

                  <Modal
                    className="modal-primary"
                    onHide={handleCloseDelete}
                    show={deleteModal}
                    size="md"
                  >
                    <Modal.Header className="justify-content-center">
                      <label>Delete Challenge</label>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to delete this Challenge? This
                      action cannot be undone
                    </Modal.Body>
                    <div className="modal-footer">
                      <Button
                        className="btn-simple"
                        onClick={handleCloseDelete}
                        variant="outlined"
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn-simple"
                        onClick={() => handleDeleteChallenge(deleteChallengeId)}
                        variant="danger"
                        color="primary"
                      >
                        Delete Challenge
                      </Button>
                    </div>
                  </Modal>
                </>
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
}

export default withSession(ChallengeManager);
